// Components
import currencyFormat from "@/lib/currencyFormat";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { areaElementClasses } from "@mui/x-charts/LineChart";
import { SparkLineChart } from "@mui/x-charts/SparkLineChart";

import _ from "lodash";
export default function SparkLineChartCard(props) {
  const {
    data,
    chartData,
    selectedBrand,
    type = "YoY",
    showChart = false,
    handleOnClick,
  } = props;
  const selectedData = data[type];
  const theme = useTheme();
  const symbols = selectedData.trendValues > 0 ? "+" : "";
  let trendString = `${symbols}${selectedData.trendValues}%`;
  if (!_.isFinite(selectedData.trendValues)) {
    trendString = "N/A";
  }
  const trendColors = {
    up: theme.palette.success.main,
    down: theme.palette.error.main,
    neutral: theme.palette.grey[400],
  };
  const labelColors = {
    up: "success",
    down: "error",
    neutral: "default",
  };
  function AreaGradient({ color, id }) {
    return (
      <defs>
        <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor={color} stopOpacity={0.3} />
          <stop offset="100%" stopColor={color} stopOpacity={0} />
        </linearGradient>
      </defs>
    );
  }
  return (
    <Card variant="outlined" sx={{ flexGrow: 1 }}>
      <CardActionArea onClick={handleOnClick}>
        <CardContent>
          <Stack
            direction="column"
            sx={{ justifyContent: "space-between", flexGrow: "1", gap: 1 }}
          >
            <Typography noWrap variant="h6" component="p">
              {selectedBrand}
            </Typography>
            <Stack sx={{ justifyContent: "space-between" }}>
              <Stack
                direction="row"
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Stack
                  direction="column"
                  sx={{
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    noWrap
                    variant="body2"
                    component="p"
                    sx={{ color: "text.secondary" }}
                  >
                    {`${data.lastYear}`}
                  </Typography>
                  <Typography variant="body1" component="p">
                    {currencyFormat(selectedData.lastYearTotal)}
                  </Typography>
                </Stack>
                <Stack
                  direction="column"
                  sx={{
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    noWrap
                    variant="caption"
                    component="p"
                    sx={{ color: "text.secondary" }}
                  >
                    {`${data.thisYear}`}
                  </Typography>
                  <Typography variant="body1" component="p">
                    {currencyFormat(selectedData.thisYearTotal)}
                  </Typography>
                </Stack>
                <Chip
                  size="small"
                  color={labelColors[selectedData.trend]}
                  label={trendString}
                />
              </Stack>
            </Stack>
            {showChart && (
              <Box sx={{ width: "100%", height: 50 }}>
                <SparkLineChart
                  valueFormatter={(value) => currencyFormat(value)}
                  colors={[trendColors[selectedData.trend] ?? "red"]}
                  data={chartData.data ?? []}
                  area
                  showHighlight
                  showTooltip
                  xAxis={{
                    scaleType: "band",
                    data: chartData.daysInWeek ?? [], // Use the correct property 'data' for xAxis
                  }}
                  sx={{
                    [`& .${areaElementClasses.root}`]: {
                      fill: `url(#area-gradient-${selectedData.trend})`,
                    },
                  }}
                >
                  <AreaGradient
                    color={trendColors[selectedData.trend]}
                    id={`area-gradient-${selectedData.trend}`}
                  />
                </SparkLineChart>
              </Box>
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
